import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateOfferSectionsMutation = createMutationHook(
  OffersApiClient.updateOfferSections,
  {
    mutationKey: ['updateOfferSections'],
  },
)
